import type {ProductListItem} from "@songfinch/types";

export const sortedProducts = (products: ProductListItem[], sortIds: string[]) => {
    if (!products) return undefined;
    if (!sortIds) return products;

    // Reverse the sortIds and sort backwards 
    // so that products that are not in sortIds are at the end
    const reverseSortIds = [...sortIds].reverse();

    const sortedProducts = (products).sort((a, b) => {
        const indexA = reverseSortIds.indexOf(a.name);
        const indexB = reverseSortIds.indexOf(b.name);
        return indexB - indexA;
    });

    return sortedProducts;
};

export const filterProductsByIds = (products: ProductListItem[], includeIds: string[]) => {
    if (!products) return undefined;
    if (!includeIds) return products;

    return sortedProducts(products.filter((product) => includeIds.includes(product.name)), includeIds);
};
